import { Navigate, useLocation } from 'react-router-dom'

import { isAuthenticated } from '../pages/auth/login/auth'

const AuthProtected = ({ children }) => {
  const location = useLocation()

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export { AuthProtected }
